import IStepFifthModel from './IStepFifthModel';

const StepFifthModelInitialState: IStepFifthModel = {
  city: null,
  codePosti: null,
  khiabanAsli: null,
  kocheh: null,
  pelak: null,
  province: null,
  tabagheh: null,
  vahed: null,
  mobile: null,
  tel: null,
  tedadKolTabaghat: null,
  tedadKolVahedHa: null,
  isSameAddress: true,
};

export default StepFifthModelInitialState;
